<template>
  <div class="default-secondary-navigation">
    <NuxtLink
      class="default-secondary-navigation__link"
      :to="helpLink"
      @click="closeOverlay"
    >
      {{ $t('help_link_text') }}
    </NuxtLink>
    <NuxtLink
      class="default-secondary-navigation__link"
      :to="aboutLink"
      @click="closeOverlay"
    >
      {{ $t('about_link_text') }}
    </NuxtLink>
    <NuxtLink
      class="default-secondary-navigation__link"
      :to="blogLink"
      @click="closeOverlay"
    >
      {{ $t('blog_link_text') }}
    </NuxtLink>
    <AccountButton class="default-secondary-navigation__link" />
  </div>
</template>

<script setup>
  const { t: $t } = useI18n()
  const { helpLink, aboutLink, blogLink } = useLinks()
  const overlayService = useOverlayService()

  function closeOverlay() {
    overlayService.closeFlyIn()
  }
</script>

<style lang="scss">
  .default-secondary-navigation {
    display: flex;
    align-content: center;
    gap: 24px;
  }

  .default-secondary-navigation__link {
    color: var(--color-primary);
    font-size: 12px;
    line-height: 26px;
    font-weight: 400;
    transition: 0.2s color ease-in-out;
  }

  .default-secondary-navigation__link:hover {
    color: var(--color-secondary);
  }
</style>
